import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { MqttModule } from "ngx-mqtt";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MQTT_SERVICE_OPTIONS_CUST } from './services/cradle.service';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { TokenInterceptor } from './services/token.interceptor';
import { provideToastr } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    provideServiceWorker('/custom-service-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    importProvidersFrom(
      MqttModule.forRoot(MQTT_SERVICE_OPTIONS_CUST),
      ReactiveFormsModule
    ),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { verticalPosition: 'top' } },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideToastr({ closeButton: true, preventDuplicates: true, maxOpened: 1, autoDismiss: true })
  ]
};
